<template>
<section class="ui-section">
    <div class="ui-max-width">
        <ui-head class="txt-center">
            <template #head>{{$t('abouthead') }}</template>
        </ui-head>
        <div class="ui-ts-text-wrap">
            <p>{{$t('about1') }}</p>
            <p>{{$t('about2') }}</p>
            <p>{{$t('about3') }}</p>
            <p>{{$t('about4') }}</p>
            <p>{{$t('about5') }}</p>
            <p>{{$t('about6') }}</p>
            <p>{{$t('about7') }}</p>
            <centered-layout>
                <a-button href="#js-eligible" class="btn--primary" v-smooth-scroll>{{$t('ats_btn_label')}}</a-button>
            </centered-layout>

            <!--
            <ul class="ui-ts-ul">
                <li class="list1 ui-ts-li"></li>
                <li class="list2 ui-ts-li"> </li>
                <li class="list3 ui-ts-li"></li>
                <li class="list4 ui-ts-li"></li>
            </ul>
            <ol class="ui-ts-ol">
                <li class="list1 ui-ts-li"></li>
                <li class="list2 ui-ts-li"> </li>
                <li class="list3 ui-ts-li"></li>
                <li class="list4 ui-ts-li"></li>
            </ol>

-->
        </div>
    </div>
</section>
</template>

<script>
import CenteredLayoutVue from '../../components/layout/CenteredLayout.vue';
import UiAnchorButtonVue from '../../components/UiAnchorButton.vue';
import UiHeadingVue from '../../components/UiHeading.vue'
export default {
 components: {
        "ui-head": UiHeadingVue,
        "a-button": UiAnchorButtonVue,
        "centered-layout" : CenteredLayoutVue
    }
}
</script>


<style scoped>
/*EDIT COLOURS HERE*/
.ui-ts-heading {
    color: #4e5157;
}

.ui-ts-heading span {
    color: #39a8e3;
}

.ui-ts-subheading {
    color: #39a8e3;
}

.ui-ts-subheading {
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 26px;
    letter-spacing: 0.005em;
    text-align: left;
    margin-bottom: 8px;
}

.ui-ts-text-wrap {
    margin-left: 0;
}

</style>
